import {
  Button,
  ErrorMessage,
  InputField,
  Spinner,
  SuccessPopup,
} from "@/common/components";
import { useContext, useEffect, useState } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import {
  useSaveManagementCompaniesMutation,
  useUpdateManagementCompaniesMutation,
} from "@/service/AdminService";
import { validate } from "@/utils/Validations";

const ManagementCompanyDetails = () => {
  const {
    setNavHeader,
    location,
    debounceState,
    debounceErrors,
    cancel,
    labels,
    setPageHeader,
  } = useContext(PrivateContext);

  const [companyData, setCompanyData] = useState({});
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const [updateCompanyApi, { isLoading: isFetching, error }] =
    useUpdateManagementCompaniesMutation();
  const [saveCompanyApi, { isLoading: isFetching1, error: error1 }] =
    useSaveManagementCompaniesMutation();

  const onChange = async (value, state) => {
    debounceState({ ...companyData, [state]: value }, setCompanyData);
    debounceErrors(
      { ...errors, [state]: await validate(value, [state]) },
      setErrors
    );
  };

  const errorProps = (state) => {
    return {
      value: companyData[state],
      error: errors[state],
      touched: touched[state],
      touch: () => setTouched({ ...touched, [state]: true }),
    };
  };

  const checkDisabled = () => {
    return (
      Object.values(errors).some((val) => val) ||
      !companyData.name ||
      !companyData.taxId
    );
  };

  const addOrUpdateRKDetails = () => {
    // Update
    if (location?.state) {
      updateCompanyApi(companyData)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
    // Add New
    else {
      saveCompanyApi(companyData)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
  };

  useEffect(() => {
    setPageHeader(labels?.investmentVehicle?.managementCompanyDetails);
    setNavHeader(labels?.investmentVehicle?.title);

    if (location?.state?.id) {
      setCompanyData(location.state);
    }
  }, []);

  return (
    <section className="container-medium py-5">
      {(isFetching || isFetching1) && <Spinner />}
      <ErrorMessage error={error || error1} wrapperClassName="mb-3" />

      <InputField
        id="name"
        label={labels?.investmentVehicle?.name}
        maxLength={35}
        change={(e) => onChange(e, "name")}
        {...errorProps("name")}
      />
      <InputField
        id="taxId"
        type="number"
        label={labels?.investmentVehicle?.taxId}
        change={(e) => onChange(e, "taxId")}
        {...errorProps("taxId")}
      />

      <div className="d-flex gap-1 flex-row justify-content-end mt-5">
        <Button
          id="cancel"
          type="secondary"
          text={labels?.investmentVehicle?.cancel}
          wrapperClassName="col-md-4 col-6"
          click={cancel}
        />
        <Button
          id="done"
          text={
            location?.state
              ? labels?.investmentVehicle?.update
              : labels?.investmentVehicle?.submit
          }
          wrapperClassName="col-md-4 col-6"
          disabled={checkDisabled()}
          click={addOrUpdateRKDetails}
        />
      </div>

      <SuccessPopup
        showModal={showPopup}
        buttonText={labels?.investmentVehicle?.continue}
        click={cancel}
        body={labels?.investmentVehicle?.requestCompleted}
      />
    </section>
  );
};

export default ManagementCompanyDetails;
